import { Navigate, useParams } from "react-router-dom";
import { getRouteTokenPrefix } from "../../lib/routeTokens";

/** Redirects old /t/{token} bookmarks to /du/{token} (same opaque token). */
const LegacyTokenPrefixRedirect = () => {
  const { routeToken } = useParams();
  return <Navigate to={`${getRouteTokenPrefix()}/${routeToken}`} replace />;
};

export default LegacyTokenPrefixRedirect;
